module.exports = __webpack_public_path__ + "img/03.d421fa7c.gif";